import config from "config";
import Rollbar from "rollbar";

const rollbar = new Rollbar({
  accessToken: config.rollbar.accessToken,
  environment: config.rollbar.env,
  captureUncaught: true,
  captureUnhandledRejections: true,
});

export default rollbar;
